import styled from 'styled-components/native';

// TouchableOpacity do próprio React Native, e NÃO o `RectButton` do
// react-native-gesture-handler que estava aqui antes.
//
// O RNGH v2 exige um `GestureHandlerRootView` envolvendo o app para que seus
// botões recebam eventos — e esse wrapper não existe em lugar nenhum deste
// projeto. Resultado: o `onPress` do RectButton nunca disparava e todo texto
// deste componente ficava inerte (o "Voltar" do cabeçalho, os links de
// login/cadastro, etc.), sem nenhum erro no console. Ao lado deles, ícones com
// `onPress` funcionavam normalmente, porque usam o sistema de toque do RN.
export const Container = styled.TouchableOpacity`
  padding: ${({ padding }) => (padding ? padding : '0.2rem')};
  justify-content: ${({ justifyContent }) => (justifyContent ? justifyContent : 'center')};
  align-self: ${({ alignSelf }) => (alignSelf ? alignSelf : 'center')};
  cursor: pointer;
`;
